import React from "react";
import {
  createTheme,
  ThemeProvider,
  makeStyles,
} from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";
import {
  InputAdornment,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import useSearchSuggestions from "../hooks/useSearchSuggestions";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&:hover $notchedOutline": {
          border: "1px solid #4c6ef5;", // Remove hover border styles
        },
        "&$focused $notchedOutline": {
          border: "1px solid #4c6ef5;", // Remove focus border styles
        },
      },
    },
    MuiFormControl: {
      root: {
        width: "100%",
        margin: "auto",
      },
    },
    MuiTypography: {
      body1: {
        fontSize: 14,
      },
    },
  },
});

const useStyles = makeStyles((theme) => ({
  input: {
    paddingLeft: theme.spacing(2),
    display: "flex",
    width: "100%",
    height: 56,
    gap: "12.276px",
    flexShrink: 0,
    borderRadius: 4,
    border: "1px solid #CED4DA",
    background: "#FFF",
    fontSize: 14,
  },
  input2: {
    paddingLeft: theme.spacing(2),
    display: "flex",
    width: "100%",
    height: 40,
    gap: "12.276px",
    flexShrink: 0,
    borderRadius: 4,
    border: "1px solid #CED4DA",
    background: "#FFF",
    fontSize: 14,
  },
  searchIcon: {
    color: "#868E96",
  },
  list: {
    fontSize: 14,
    background: "#fff",
    margin: "auto",
    "&:hover": {
      background: "#e8e8e8",
    },
    zIndex: 9,
  },
  list2: {
    fontSize: 14,
    background: "#fff",
    width: "auto",
    maxWidth: 796,
    margin: "auto",
    "&:hover": {
      background: "#e8e8e8",
    },
  },
}));

const SearchInput = withRouter(({ maxWidth = "100%", location }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const isBaseURL =
    window.location.pathname === "/" && window.location.search === "";

  const {
    searchQuery,
    suggestions,
    handleSearchInputChange,
    handleClearClick,
    handleResultClick,
    handleSearchKeyDown,
  } = useSearchSuggestions();
  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          width: "100%",
          textAlign: "center",
          height: isBaseURL ? 56 : 40,
        }}
      >
        <TextField
          placeholder={t("Search")}
          variant="outlined"
          value={searchQuery}
          style={{ maxWidth }}
          onChange={handleSearchInputChange}
          onKeyDown={handleSearchKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className={classes.searchIcon} />
              </InputAdornment>
            ),
            endAdornment: searchQuery && (
              <InputAdornment position="end">
                <IconButton onClick={handleClearClick} edge="end">
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
            className: isBaseURL ? classes.input : classes.input2,
          }}
        />
        <List>
          {suggestions.map((result) => (
            <ListItem
              button
              key={result.headerExternalId}
              onClick={() => handleResultClick(result)}
              className={isBaseURL ? classes.list : classes.list2}
            >
              <ListItemText primary={result.headerExternalId} />
            </ListItem>
          ))}
        </List>
      </div>
    </ThemeProvider>
  );
});

export default SearchInput;
